import axios from 'axios';
import { API_BASE } from '../config';

// دریافت آمار کلی پروژه/کلینیک/صفحه/فرم
export const getDashboardStats = async ({type, startDate, endDate, search}={}) => {
  const token = localStorage.getItem('token');
  const res = await axios.get(`${API_BASE}dashboard/stats`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
        type,
        startDate,
        endDate,
        search
      }
  });
  return res.data;
};

// دریافت ساختار درختی پروژه‌ها
export const getTreeData = async ({ page = 1, limit = 20, type, startDate, endDate, search } = {}) => {
  try {
    const token = localStorage.getItem('token');

    const res = await axios.get(`${API_BASE}dashboard/tree`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        page,
        limit,
        type,
        startDate,
        endDate,
        search
      }
    });

    return res.data;
  } catch (error) {
    console.error('Error fetching tree data:', error);
    throw error;
  }
};


export const getFormsByPageId = async (pageId) => {
    const token = localStorage.getItem('token');
    const res = await axios.get(`${API_BASE}forms/page/${pageId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data;
  };
  